module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAIaGhudNAP81HP8YDPsYAOccAP8MAP8EAOsIBPMAAOMAADUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAACH5BAEHABsALAAAAAAgACAAAAXq4CaOZGmeaGpqrKa+K+nCsHYc4j3TqH3fiMRgx5P9DokE4kcs+n7K46FZs7EymqV0CgN4W1NNplLZIgpUE6Bls1ha5R9iuUnLNJXLYYlptB5AdHUqLBMTQDcNfiwVCksDInZ1YD8GBgcMEiwXNgMDOHZsWz8SERqcnjo9Gm6jB6kLCyxMq3iuNwQ6s1wnT7e3oUi7v7osPcKUvxAUxr0+bL5HAgcOLSk2AcXDUmwA14gJLRjRYSxe39yiP5zN3uhH0DdYzTQ+jjpus9ZFdVsaE/okEfL3jF8JX5ZUGTzob2EvJgINsnFIEUYIADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadNE_S6.gif
// module id = bPjP
// module chunks = 48